<template>
    <re-b-modal ref="treeModal" :loading="loading" :header="header" @ok="whenOkClicked" @show="forceQuery">
        <b-overlay :show="loading">
            <em-filter-tree filterEnable ref="emTree"
                            :entity="entity"
                            filterState="levelTreeFilter"
                            loadState="levelTreeNodes"
                            :checked-ids="checkedIds"
                            check-enable
                            enable-switch-check-related>
            </em-filter-tree>
        </b-overlay>
    </re-b-modal>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import EmFilterTree from "@/components/em/EmFilterTree";

export default {
    name: "FilterTreeModal",
    components: {ReBModal, EmFilterTree},
    props: {
        header: {
            type: String,
            default: "选择"
        },
        entity: {
            type: String,
            required: true
        },
        checkedIds: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        forceQuery() {
            this.$nextTick(() => this.$refs.emTree && this.$refs.emTree.doFilterQuery());
        },
        getCheckedNodes() {
            return this.$refs.emTree.getCheckedNodes();
        },
        whenOkClicked() {
            this.$emit('checkFinish', this.getCheckedNodes());
        },

        showModal() {
            this.$refs.treeModal.showModal();
        },
        changeLoading(val) {
            this.loading = val;
        }
    }
}
</script>

<style scoped>

</style>